import statesOptions from '../data/states.json';
import taxClassifications from '../data/taxClassifications.json';
import validations from '../data/validations.json';

AgencyController.$inject = [
  'ApplicationService',
  '$scope',
  '$location',
  '$window',
  '$q'
];

function AgencyController (ApplicationService, $scope, $location, $window, $q) {
  function init () {
    var formData = ApplicationService.getData();
    $scope.previouslyAppointed = formData.previouslyAppointed;
    $scope.agencyInformation = formData.agencyInformation;
    $scope.today = new Date();
    $scope.futureDate = new Date().setFullYear($scope.today.getFullYear() + 20);
    $scope.taxClassifications = taxClassifications;
    $scope.validations = validations;
    $scope.statesOptions = statesOptions;
    $scope.submitForm = submitForm;
    $scope.previousStep = previousStep;
    $scope.$watch('agencyInformation.businessState', updateLicenses);
  }

  $scope.editAddress = function () {
    $scope.addressErrorDetails = null;
    $window.scrollTo(0, 0);
  };

  $scope.selectAddress = function (address) {
    var agencyInformation = ApplicationService.getData().agencyInformation;
    agencyInformation.businessAddress = address.address;
    agencyInformation.businessAddress2 = address.address2;
    agencyInformation.businessCity = address.city;
    agencyInformation.businessState = address.state;
    agencyInformation.businessZipCode = address.zipCode;
    $scope.agencyInformation = agencyInformation;
    ApplicationService.setData({
      agencyInformation: agencyInformation
    });
    nextPage();
  };

  function updateLicenses () {
    var existingLicenses = $scope.agencyInformation.agencyLicenses;
    var residencyState = $scope.agencyInformation.businessState;
    $scope.agencyInformation.agencyLicenses = ApplicationService.generateLicenses(existingLicenses, residencyState, true);
  }

  function previousStep () {
    $location.path('/application/broker-information');
  }

  function submitForm (form) {
    $window.scrollTo(0, 0);
    if (form.$valid) {
      nextStep();
    }
  }

  function nextStep () {
    // if user hits "no" - lets not keep any entered data
    var data = {
      agencyInformation: $scope.agencyInformation
    };
    if ($scope.agencyInformation.usingAgency) {
      data.agencyInformation.businessAddress2 = (data.agencyInformation.businessAddress2 || '');
    } else {
      data = {
        agencyInformation: {
          generalAgencyName: $scope.agencyInformation.generalAgencyName,
          usingAgency: false
        }
      };
    }

    ApplicationService.setData(data);

    $scope.loading = true;

    var promises = [];

    if (data.agencyInformation.usingAgency) {
      promises.push(validateAddress(data));
    }

    $q.all(promises).then(function () {
      nextPage();
    }).catch(function () {
      $scope.loading = false;
    });
  }

  function validateAddress (data) {
    return $q(function (resolve, reject) {
      ApplicationService.validateAddress({
        address: data.agencyInformation.businessAddress,
        address2: data.agencyInformation.businessAddress2,
        city: data.agencyInformation.businessCity,
        state: data.agencyInformation.businessState,
        zipCode: data.agencyInformation.businessZipCode
      })
      .then(function () {
        $scope.addressErrorDetails = null;
        resolve();
      }, function (response) {
        $scope.addressErrorDetails = response;
        reject();
      });
    });
  }

  function nextPage () {
    $location.path('/application/commission-assignment');
  }

  init();
}

export default AgencyController;



//////////////////
// WEBPACK FOOTER
// ./src/js/controllers/AgencyInformationController.js
// module id = 19
// module chunks = 0